var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-col',{staticClass:"ml-1",attrs:{"cols":"12","md":"6"}},[_c('table-render',{attrs:{"id":"advanced","show-checkboxes":false,"schema":_vm.schema,"rows":_vm.rows,"actions":_vm.actions}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }